import { Card, Group, Select, Text, TextInput, rem } from '@mantine/core';
import { useEmployeeFormContext } from '../EmployeePersonalSection';
import { DateInput, type DateValue } from '@mantine/dates';
import { dateFormat, dateFormatUI } from '@/index';
import dayjs from 'dayjs';
import 'dayjs/locale/cs';
import { BiSolidDownArrow } from 'react-icons/bi';
import { type Mapping } from '@/schemas/API/GET/mapping/response';
import useSWR from 'swr';
import { MappingToComboBoxItem } from '@/schemas/converters/mappingShemasConverter';
import { getFetcher } from '@/api/fetchers';

export const PersonalInfoCard: React.FC = () => {
  const form = useEmployeeFormContext();
  const icon = (
    <BiSolidDownArrow
      style={{ width: rem(10), height: rem(10), color: 'gray' }}
    />
  );

  const { data: genderMap } = useSWR<Mapping>('/mappings/sexes', getFetcher);

  const setDate = (value: DateValue) => {
    const date: string = dayjs(value).format(dateFormat);
    form.setFieldValue('birthdate', date);
  };

  const setTitle = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value.trim() === '' ? null : event.target.value;
    form.setFieldValue('title', value);
  };

  return (
    <Card shadow="sm" padding="md" radius="md" withBorder>
      <Text fw={700} size="lg">
        Osobní informace
      </Text>
      <TextInput
        mt="sm"
        variant="filled"
        radius="md"
        placeholder="titul"
        label="Titul"
        value={form.getInputProps('title').value}
        error={form.getInputProps('title').error}
        onChange={setTitle}
      />
      <Group justify="space-between" grow align="start">
        <TextInput
          mt="sm"
          variant="filled"
          radius="md"
          placeholder="jméno"
          label="Jméno"
          {...form.getInputProps('firstName')}
        />

        <TextInput
          mt="sm"
          variant="filled"
          radius="md"
          placeholder="příjmení"
          label="Příjmení"
          {...form.getInputProps('lastName')}
        />
      </Group>
      <Select
        mt="sm"
        variant="filled"
        radius="md"
        label="Pohlaví"
        allowDeselect={false}
        rightSection={icon}
        data={MappingToComboBoxItem(genderMap)}
        {...form.getInputProps('sex')}
      />
      <TextInput
        mt="sm"
        variant="filled"
        radius="md"
        placeholder="místo narození"
        label="Místo narození"
        {...form.getInputProps('birthplace')}
      />
      <DateInput
        mt="sm"
        variant="filled"
        radius="md"
        label="Datum narození"
        placeholder="datum narození"
        rightSection={icon}
        valueFormat={dateFormatUI}
        value={
          form.values.birthdate ? dayjs(form.values.birthdate).toDate() : null
        }
        onChange={setDate}
        error={form.getInputProps('birthdate').error}
        locale="cs"
      />
    </Card>
  );
};
